import { Suspense, lazy, useCallback, useState } from "react";
import { Editor } from "@tiptap/core";
import { DndHandleButton } from "../../../../components/Dnd/DndHandleButton";
import styles from "../RichTextEditor.module.scss";

const DragHandle = lazy(() =>
  import("@tiptap/extension-drag-handle-react").then((m) => ({
    default: m.DragHandle,
  })),
);

type RichTextEditorDragHandleProps = {
  editor: Editor;
};

export function RichTextEditorDragHandle({
  editor,
}: RichTextEditorDragHandleProps) {
  const [isDragging, setIsDragging] = useState(false);

  // Stable refs prevent the underlying DragHandle from re-registering its
  // ProseMirror plugin on every parent render, which interferes with the
  // suggestion plugin (e.g. mention popover closes mid-flight).
  const handleDragStart = useCallback(() => setIsDragging(true), []);
  const handleDragEnd = useCallback(() => setIsDragging(false), []);

  return (
    <Suspense>
      <DragHandle
        className={styles["drag-handle"]}
        editor={editor}
        onElementDragStart={handleDragStart}
        onElementDragEnd={handleDragEnd}
      >
        <DndHandleButton
          isActive={isDragging}
          aria-label="Drag to reorder block"
        />
      </DragHandle>
    </Suspense>
  );
}
